import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useLocation, useNavigate } from 'react-router-dom';
import AddEditUnitForm from './unitEdit/AddEditUnitForm';
import { addUnit } from '../../redux/actions/unitActions';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';
import Overlay from '../shared/Overlay';

/**
 * The component to add a new unit
 * @param {object} props - Props passed to this component
 * @description - This is the container for the add new unit form. This uses the overlay component and passes information down to the addeditunitform component.
 * @returns {object} The contents of the form
 */
export let UnconnectedAddNewUnit = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state = {} } = location;
  const { parent_unit } = state;
  // This is the url that will be used to go back to when the modal view is closed
  const previous = state.previous || '/units/';

  /**
   * Function to submit the values from the `add unit` form to add the unit to the database
   * @param {object} values - The values from the form
   * @fires dispatch#addUser - Sends the values from the form to trigger the addUnit action
   */
  const newUnitSubmit = (values) => {
    props.dispatch(addUnit(values, navigate, previous));
  };

  return (
    <Overlay rootUrl={previous} canClose={true} data-test="add-unit-overlay">
      <div className="content-container content-container--column">
        <FormattedMessage
          id="addNewUnitForm.addUnitTitle"
          defaultMessage="Add a New Unit"
          description="The title for the page to add a unit"
          data-test="form-header">
          {(txt) => (
            <h1 className="no-margin  text-center" data-test="form-header-text">
              {txt}
            </h1>
          )}
        </FormattedMessage>

        <p>
          <FormattedMessage
            id="addNewUnitForm.formDescription"
            defaultMessage="This form is used to add a new unit. If you have selected 'add child unit' from the dropdown or under a column header, that unit will automatically be set as the parent unit for the unit you are creating. If you want to change this, just deselect the listed unit and select another one."
            description="Description text about the add unit interface"
          />
        </p>
        <hr />
        <AccessControl
          data-test="access-control"
          feature={permissions.static.units.addUnit}
          permissionMessage={true}>
          <AddEditUnitForm
            onSubmit={newUnitSubmit}
            parent_unit={parent_unit}
            previous={previous}
            data-test="add-unit-form"
          />
        </AccessControl>
      </div>
    </Overlay>
  );
};

export default connect()(UnconnectedAddNewUnit);
